import { render, staticRenderFns } from "./redirects-card.vue?vue&type=template&id=5316e92e"
import script from "./redirects-card.vue?vue&type=script&lang=js"
export * from "./redirects-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports